import React, { forwardRef } from 'react'

import { IconProps } from './types'

const CurvedArrowDownRight = forwardRef<SVGSVGElement, IconProps>(
  ({ size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 1C7.5 0.723858 7.27614 0.5 7 0.5C6.72386 0.5 6.5 0.723858 6.5 1H7.5ZM15.3536 9.35355C15.5488 9.15829 15.5488 8.84171 15.3536 8.64645L12.1716 5.46447C11.9763 5.2692 11.6597 5.2692 11.4645 5.46447C11.2692 5.65973 11.2692 5.97631 11.4645 6.17157L14.2929 9L11.4645 11.8284C11.2692 12.0237 11.2692 12.3403 11.4645 12.5355C11.6597 12.7308 11.9763 12.7308 12.1716 12.5355L15.3536 9.35355ZM6.5 1V5H7.5V1H6.5ZM11 9.5H15V8.5H11V9.5ZM6.5 5C6.5 7.48528 8.51472 9.5 11 9.5V8.5C9.067 8.5 7.5 6.933 7.5 5H6.5Z"
        fill="currentColor"
      />
    </svg>
  ),
)
CurvedArrowDownRight.displayName = 'CurvedArrowDownRight'

export default CurvedArrowDownRight
